import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, catchError, Observable, of } from "rxjs";
import { ApiPayload, ApiResponse, API_STATUS } from "../../model/api.model";
import { FETCH_METHODS } from "../../model/common.model";
import { FieldOption } from "../../model/form.model";
import { CommonUtils } from '../../utils/common.utils';


const token: any = sessionStorage.getItem('token') == null ? '' : sessionStorage.getItem('token')
const idTok: any = sessionStorage.getItem('id_token') == null ? '' : sessionStorage.getItem('id_token')
const isIEOrEdge = /msie\s|trident\/|edge\//i.test(globalThis.navigator.userAgent);
let httpOptions: any;
const contentType = 'application/json';
if (isIEOrEdge) {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': contentType,
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Authorization': token,
      'IdToken': idTok
    })
  };
} else {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': contentType,
      'Authorization': token,
      'IdToken': idTok
    })
  };
}
@Injectable({
  providedIn: 'root'
})
export class ApiService {
  
  constructor(private readonly https:HttpClient, private readonly commonUtils: CommonUtils) {}
  readonly options: Record<string, FieldOption[]> = {};
  private readonly apiMethodNotFoundMsg = 'No Api path matched, kindly contact your Administrator';
  fetchAllData(params:ApiPayload){
    try{
      if(params['type'] !== 'token'){
      params['url'] = params['url']+'/{proxy+}'
      }
      if(params['method'] === FETCH_METHODS['Post']){
        return this.postMethod(params);
      }else if(params['method'] === FETCH_METHODS['Get']){
        return this.getMethod(params);
      }else{
        const errorResponse:ApiResponse = {
          result:[],
          status:API_STATUS['Error'],
          errorMsg:this.apiMethodNotFoundMsg
        }
        return this.responseHandler(errorResponse)
      }
    }catch(err){
      this.commonUtils.spinner('hide');
      const errorResponse:ApiResponse = {
        result:[],
        status:API_STATUS['Error'],
        errorMsg:err?.toString()
      }
      return this.responseHandler(errorResponse)
    }

  }
  postMethod(apiConfig:ApiPayload){
    const url = apiConfig['url'];
    const postBody = apiConfig['body'] ?? {};
    const options = this.getHeader(apiConfig['headers']) ?? {};
    return this.https.post(url, postBody, options).pipe(
      map(this.handleResponse.bind(this)),
      catchError(error => this.responseHandler(error))
    );
  }
  getMethod(apiConfig:ApiPayload){
    let url = apiConfig['url'];
    const options = this.getHeader(apiConfig['headers']) ?? {};
    if(apiConfig['body']){
    const queryParams = this.makeQueryparams(apiConfig['body']);
    if(queryParams!==''){
      url+=`?${queryParams}`;
    }
  }
    return this.https.get(url, options).pipe(
      map(this.handleResponse.bind(this)),
      catchError(error => this.responseHandler(error))
    );
  }
  makeQueryparams(body:any){
    let queryparams = "";
    Object.keys(body).forEach(key=>{
      if(queryparams!== ''){
        queryparams+='&'
      }
      queryparams +=`${key}=${body[key]}`;
    })
    return queryparams;
  }
  responseHandler(response: ApiResponse): Observable<ApiResponse> {
    return of(response);
  }
  handleResponse(result:any):ApiResponse{
    if(result['access_token']){
      return result
    }
    if(result['statusCode'] === 404){
      return {
        result: [],
        status: API_STATUS['Error']
      }
    }
    if(!result['payload'] || (result?.['payload'].length>=1 && result['payload'][0] === null)){
      result['payload'] = [];
    }

    return {
      result:result['payload'],
      status:API_STATUS['Success']
    };
  }
  getErrorResponse(msg:string){
    const errorResponse:ApiResponse = {
      result:[],
      status:API_STATUS['Error'],
      errorMsg:msg
    }
    return this.responseHandler(errorResponse)
  }
  getSuccessResponse(result:any){
    const errorResponse:ApiResponse = {
      result:result,
      status:API_STATUS['Success']
    }
    return this.responseHandler(errorResponse)
  }

getHeader(headers: any) {
  const token: any = sessionStorage.getItem('token') == null ? '' : sessionStorage.getItem('token')
  const idTok: any = sessionStorage.getItem('id_token') == null ? '' : sessionStorage.getItem('id_token')
  const isIEOrEdge = /msie\s|trident\/|edge\//i.test(globalThis.navigator.userAgent);

  const defaultHeaders: any = {
    'Authorization': token,
    'IdToken': idTok,
    ...(headers || { 'Content-Type': contentType }),
    ...(isIEOrEdge && {
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache'
    })
  };

  return {
    headers: new HttpHeaders(defaultHeaders)
  };
}
}

